module.exports = __webpack_public_path__ + "static/img/cailiaojiagong.182b2358.jpg";